var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4444 24.7778C45.4444 24.7778 45.4444 18.7889 45.4444 17.4444C45.4444 9.98889 39.4556 4 32 4C24.5444 4 18.5556 9.98889 18.5556 17.4444C18.5556 18.7889 18.5556 24.7778 18.5556 24.7778M12.4444 59C11.1 59 10 57.9 10 56.5556V27.2222C10 25.8778 11.1 24.7778 12.4444 24.7778H51.5556C52.9 24.7778 54 25.8778 54 27.2222V56.5556C54 57.9 52.9 59 51.5556 59H12.4444Z",
    stroke: "#FF7500",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6667 41.3542C35.6667 39.2764 34.0778 37.6875 32 37.6875C29.9222 37.6875 28.3333 39.2764 28.3333 41.3542C28.3333 42.4542 28.8222 43.4319 29.5556 44.0431V47.4653C29.5556 48.8097 30.6556 49.9097 32 49.9097C33.3445 49.9097 34.4445 48.8097 34.4445 47.4653V44.0431C35.1778 43.4319 35.6667 42.4542 35.6667 41.3542Z",
    fill: "#FF7500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.141e9f10dc9fbaa6f155b4abc125ffeb.svg";
export { ForwardRef as ReactComponent };